module.exports = __webpack_public_path__ + "static/media/AutorinnenPortrait_KerstinWoerdehoff.e4e509a9.jpg";